export enum TrainedMsRoutes {
  AdjustForContTraining = 'adjust-for-cont-training',
  DeleteManyByBsHash = 'delete-many-by-bs-hash',
  FindMany = 'find-many',
  FindManyByBsHash = 'find-many-by-bs-hash',
  UpsertOne = 'upsert-one',
}
